export default {
	pitches: '/pitches',
	importPitches: '/pitches/import',
	pitch: (id: number) => `/pitches/${id}`,
	pitchReleases: '/pitches/releases',
};
